module.exports = __webpack_public_path__ + "static/media/pic_top@2x.3ef0d1a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_top@2x.jpg
// module id = 658
// module chunks = 0